import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Auth from "../Pages/auth";
import Contatos from "../Pages/Contatos";
import Faq from "../Pages/Faq";
import FooterLogado from "../Pages/Footer";
import HeaderLogado from "../Pages/HeaderLogado";
import HomeDeslogado from "../Pages/HomeDeslogado";
import HomeLogado from "../Pages/HomeLogado";
import MaisPremios from "../Pages/MaisPremios";
import MeusDados from "../Pages/MeusDados";
import MeusPontos from "../Pages/MeusPontos";
import MeusVouchers from "../Pages/MeusVouchers";
import BarraPolitica from "../Pages/Politica/BarraPolitica";
import Produto from "../Pages/Produto";
import Regulamento from "../Pages/Regulamento";
import TransferenciaPontos from "../Pages/TransferenciaPontos";
import VitrineLeo from "../Pages/VitrineLeo";
import storage from "../services/storage";
import ApiServices from "../services/apiServices";
import Novidades from "../Pages/Novidades";
import Retrospectiva from "../Pages/Retrospectiva";
import Pesquisa from "../Pages/Pesquisa";
import PesquisaResponder from "../Pages/Pesquisa/indexEditar";
import ProdutoTimeDeCraque from "../Pages/ProdutoTimeDeCraque"; 
import TimeDeCraques from "../Pages/TimeDeCraques";

const PrivateRoutes = ({ children, redirectTo, path = null }) => {
  const autenticado = storage?.get("TOKEN") != null;
  if (path === "/catalogo/vitrine-leo/campanha" && !autenticado) {
    storage.set("IR-CAMPANHA", true);
  }

  return autenticado ? (
    <>
      <HeaderLogado /> {children} <FooterLogado />
    </>
  ) : (
    <>
      <Navigate to={redirectTo} />
    </>
  );
};

export default function Rotas() {
  async function fnGestaoMenu() {
    try {
      let response = await ApiServices.apiGet("gestao-menu");
      storage.set("gestaoMenu", response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
    }
  }
  useEffect(() => {
    fnGestaoMenu();
  }, []);

  return (
    <>
      <Routes>
        <Route exact path="*" element={<Auth />} />
        <Route exact path="/deslogado" element={<HomeDeslogado />} />
        <Route exact path="/home" element={<PrivateRoutes redirectTo={"/deslogado"}><HomeLogado /></PrivateRoutes>} />
        <Route exact path="/novidades" element={<PrivateRoutes redirectTo={"/deslogado"}><Novidades /></PrivateRoutes>} />
        <Route exact path="/catalogo/vitrine-leo" element={<PrivateRoutes redirectTo={"/deslogado"}><VitrineLeo /></PrivateRoutes>} />
        <Route exact path="/catalogo/vitrine-leo-time-de-craque" element={<PrivateRoutes redirectTo={"/deslogado"}><VitrineLeo /></PrivateRoutes>} />
        <Route exact path="/catalogo/vitrine-leo/campanha" element={<PrivateRoutes redirectTo={"/deslogado"}><VitrineLeo /></PrivateRoutes>} />
        <Route exact path="/catalogo/vitrine-leo/:id" element={<PrivateRoutes redirectTo={"/deslogado"}><Produto /></PrivateRoutes>} />
        <Route exact path="/catalogo/vitrine-leo-time-de-craque/:id" element={<PrivateRoutes redirectTo={"/deslogado"}><ProdutoTimeDeCraque /></PrivateRoutes>} />
        <Route exact path="/catalogo/mais-premios" element={<PrivateRoutes redirectTo={"/deslogado"}><MaisPremios /></PrivateRoutes>} />
        <Route exact path="/catalogo/time-de-craques" element={<PrivateRoutes redirectTo={"/deslogado"}><TimeDeCraques /></PrivateRoutes>} />
        <Route exact path="/extrato/meus-vouchers" element={<PrivateRoutes redirectTo={"/deslogado"}><MeusVouchers /></PrivateRoutes>} />
        <Route exact path="/extrato/meus-pontos" element={<PrivateRoutes redirectTo={"/deslogado"}><MeusPontos /></PrivateRoutes>} />
        <Route exact path="/transferencia-de-pontos" element={<PrivateRoutes redirectTo={"/deslogado"}><TransferenciaPontos /></PrivateRoutes>} />
        <Route exact path="/contatos" element={<PrivateRoutes redirectTo={"/deslogado"}><Contatos /></PrivateRoutes>} />
        <Route exact path="/faq" element={<PrivateRoutes redirectTo={"/deslogado"}><Faq /></PrivateRoutes>} />
        <Route exact path="/regulamento" element={<PrivateRoutes redirectTo={"/deslogado"}><Regulamento /></PrivateRoutes>} />
        <Route exact path="/pesquisa" element={<PrivateRoutes redirectTo={"/deslogado"}><Pesquisa /></PrivateRoutes>} />
        <Route exact path="/pesquisa/:id" element={<PrivateRoutes redirectTo={"/deslogado"}><PesquisaResponder /></PrivateRoutes>} />
        <Route exact path="/retrospectiva" element={<PrivateRoutes redirectTo={"/deslogado"}><Retrospectiva /></PrivateRoutes>} />
        <Route exact path="/meus-dados" element={<PrivateRoutes redirectTo={"/deslogado"}><MeusDados /></PrivateRoutes>} />
      </Routes>

      {storage.get("POLITICA") !== "true" && <BarraPolitica />}
    </>
  );
}

